import { render } from "./v-main-wrapper.vue?vue&type=template&id=ad20e26c"
import script from "./v-main-wrapper.vue?vue&type=script&lang=js"
export * from "./v-main-wrapper.vue?vue&type=script&lang=js"
script.render = render

export default script